import { Text } from '@instructure/ui'

export const RequiredLabel = (label: string | React.ReactNode) => (
  <>
    {label}&nbsp;<Text color="danger">*</Text>
  </>
)
